import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { tabTypes } from "../../constants/tab-types";
import { TabList, Tab } from "@ebscois/react-component-library";
import { StyledTabsWrapper } from "./styled";

const ResponsiveTabs = ({
  tabs,
  getSectionName,
  activeDrugDetailSection,
  activeTabPath,
}) => {
  const history = useHistory();
  const handleClick = useCallback(
    (path) => {
      let newPath = path;
      if (
        activeTabPath === tabs[0].path &&
        path.split("/")[3] === tabTypes.DETAILS
      ) {
        const sectionName = getSectionName();
        if (sectionName !== null) {
          newPath = `${path}/${sectionName}`;
        }
      }
      if (
        activeTabPath.split("/")[3] === tabTypes.DETAILS &&
        path === tabs[0].path &&
        activeDrugDetailSection
      ) {
        newPath = `${path}#${activeDrugDetailSection}`;
      }
      history.push(newPath);
    },
    [history, activeTabPath, tabs, getSectionName, activeDrugDetailSection]
  );
  const activeTabIndex = tabs?.findIndex((tab) => tab.path === activeTabPath);
  return (
    <>
      {tabs && (
        <StyledTabsWrapper data-testid="content-tabs">
          <TabList
            data-testid="tab-list"
            aria-label="content"
            activeTab={activeTabIndex}
          >
            {tabs.map(({ path, label, icon, testId }) => (
              <Tab
                id={testId}
                data-testid={testId}
                aria-controls={`${testId}-panel`}
                label={label}
                key={path}
                onClick={() => {
                  handleClick(path);
                }}
                icon={icon?.glyph}
              />
            ))}
          </TabList>
        </StyledTabsWrapper>
      )}
    </>
  );
};

ResponsiveTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.shape({
        glyph: PropTypes.string.isRequired,
        color: PropTypes.string,
        size: PropTypes.string,
      }),
    }).isRequired
  ).isRequired,
};

ResponsiveTabs.displayName = "ResponsiveTabs";

export default ResponsiveTabs;
